const ACTION_NAMESPACE = '/SERVICES_SANTE'

export const GET_SERVICES = `${ACTION_NAMESPACE}/GET_SERVICES`
export const GET_SERVICE_PROFIL = `${ACTION_NAMESPACE}/GET_SERVICES_PROFIL`
export const GET_SERVICES_LOADING = `${ACTION_NAMESPACE}/GET_SERVICES_LOADING`
export const GET_SERVICE_PROFIL_LOADING = `${ACTION_NAMESPACE}/GET_SERVICE_PROFIL`
export const GET_MENTIONS_LEGALES = `${ACTION_NAMESPACE}/GET_MENTIONS_LEGALES`
export const GET_MENTIONS_LEGALES_LOADING = `${ACTION_NAMESPACE}/GET_MENTIONS_LEGALES_LOADING`
